<div class="d-flex justify-content-center date-time-input-container w-100">
  <div class="w-100 position-relative">
    <input
      pInputText
      type="text"
      class="w-100 main-trigger"
      [class.active]="open()"
      [class.filled]="value().start !== null || value().end !== null"
      [disabled]="disabled()"
      [readonly]="true"
      [value]="value().start !== null || value().end !== null ? displayText() : ''"
      [placeholder]="placeholder()"
      (click)="toggleOpen(); op.toggle($event)"
      (keydown)="$event.preventDefault()"
      data-testid="toggle-open-btn"/>

    <p-popover #op>
      <div class="small mb-2">
        {{ translationSchema.sharedComponents.dateTimeRange.start | translate }}
      </div>

      <div class="row g-2 align-items-stretch mb-3">
        <div class="col-8">
          <p-datePicker
            [ngModel]="draftStart()"
            (ngModelChange)="setDraftStartDate($event)"
            [showIcon]="true"
            [showButtonBar]="true"
            [disabled]="disabled()"
            [readonlyInput]="true"
            placeholder="{{ translationSchema.sharedComponents.dateRange.start | translate }}"
            inputId="startDate"
            dateFormat="yy-mm-dd"
            [style]="{ width: '100%' }" data-testid="draft-start-datepicker"></p-datePicker>
        </div>

        <div class="col-4">
          <p-iconfield>
            <p-inputicon styleClass="pi pi-clock"></p-inputicon>
            <input
              pInputText
              type="text"
              class="w-100 text-center"
              [disabled]="disabled() || draftStart() === null"
              [ngModel]="draftStartTime()"
              (ngModelChange)="setDraftStartTime($event)"
              [ngModelOptions]="{ updateOn: 'blur' }"
              (keydown.enter)="setDraftStartTime($any($event.target).value)"
              maxlength="5"
              inputmode="numeric"
              placeholder="HH:mm" data-testid="draft-start-time-input"/>
          </p-iconfield>
        </div>
      </div>

      <div class="small mb-2">
        {{ translationSchema.sharedComponents.dateTimeRange.end | translate }}
      </div>

      <div class="row g-2 align-items-stretch mb-4">
        <div class="col-8">
          <p-datePicker
            [ngModel]="draftEnd()"
            (ngModelChange)="setDraftEndDate($event)"
            [showIcon]="true"
            [showButtonBar]="true"
            [disabled]="disabled()"
            [readonlyInput]="true"
            [minDate]="draftStart()"
            placeholder="{{ translationSchema.sharedComponents.dateRange.end | translate }}"
            inputId="endDate"
            dateFormat="yy-mm-dd"
            [style]="{ width: '100%' }" data-testid="draft-end-datepicker"></p-datePicker>
        </div>

        <div class="col-4">
          <p-iconfield>
            <p-inputicon styleClass="pi pi-clock"></p-inputicon>
            <input
              pInputText
              type="text"
              #endTimeInput
              class="w-100 text-center"
              [disabled]="disabled() || draftEnd() === null"
              [ngModel]="draftEndTime()"
              (ngModelChange)="setDraftEndTime($event); endTimeInput.value = draftEndTime()"
              [ngModelOptions]="{ updateOn: 'blur' }"
              (keydown.enter)="setDraftEndTime($any($event.target).value)"
              maxlength="5"
              inputmode="numeric"
              placeholder="HH:mm" data-testid="draft-end-time-input"/>
          </p-iconfield>
        </div>
      </div>
    </p-popover>
  </div>
</div>


